/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContractSearchResult } from './APIContractSearchResult';
import {
    APIContractSearchResultFromJSON,
    APIContractSearchResultFromJSONTyped,
    APIContractSearchResultToJSON,
} from './APIContractSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIContractSearchResponse
 */
export interface APIContractSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIContractSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIContractSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIContractSearchResult>}
     * @memberof APIContractSearchResponse
     */
    results: Array<APIContractSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIContractSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIContractSearchResponse interface.
 */
export function instanceOfAPIContractSearchResponse(value: object): value is APIContractSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIContractSearchResponseFromJSON(json: any): APIContractSearchResponse {
    return APIContractSearchResponseFromJSONTyped(json, false);
}

export function APIContractSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContractSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIContractSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIContractSearchResponseToJSON(value?: APIContractSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIContractSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

